import {useEffect, useMemo, useState} from "react";
import { connect } from "react-redux";

import { Actions as EMPLOYEEACTIONS } from "../../../store/actions/employeeActions";

import {
	AcademicCapIcon,
	BackwardIcon,
	BanknotesIcon,
	BuildingLibraryIcon,
	CheckBadgeIcon,
	ReceiptPercentIcon,
	PiggyBankIcon,
	UserIcon,
	UserPlusIcon,
	XMarkIcon,
} from "@/icons/solid";
import { addMonths, format } from "date-fns";

import Bank from "../bank/Bank";
import PensionDetails from "../pension/PensionDetails";
import EmployeeDetails from "../personal/EmployeeDetails";
import PersonalDetails from "../personal/PersonalDetails";
import PreviousEarnings from "../previous-earnings/PreviousEarnings";
import RoleDetails from "../role/RoleDetails";
import TaxDetails from "../tax-details/TaxDetails";
import FinalConfirmation from "./FinalConfirmation";
import EmployeeSalary from "../salary-details/EmployeeSalary";

let pageList = [
	{
		title: "Personal Details",
		child: PersonalDetails,
		icon: UserIcon,
		modalType: ["default","cis"],
		jurisdiction: ["UK", "MT"],
	},
	{
		title: "Contractor Details",
		child: EmployeeDetails,
		icon: UserIcon,
		modalType: ["cis"],
		jurisdiction: ["UK", "MT"],
	},
	{
		title: "Additional Details",
		child: EmployeeDetails,
		icon: UserPlusIcon,
		modalType: ["default"],
		jurisdiction: ["UK", "MT"],
	},
	{
		title: "Role Details",
		child: RoleDetails,
		icon: AcademicCapIcon,
		modalType: ["default", "cis"],
		jurisdiction: ["UK", "MT"],
	},
	{
		title: "Salary Details",
		child: EmployeeSalary,
		icon: BanknotesIcon,
		modalType: ["default", "cis"],
		jurisdiction: ["UK", "MT"],
	},
	{
		title: "Previous Earnings",
		child: PreviousEarnings,
		icon: BackwardIcon,
		modalType: ["default"],
		jurisdiction: ["UK", "MT"],
	},
	{
		title: "Pension Plan",
		child: PensionDetails,
		icon: PiggyBankIcon,
		modalType: ["default"],
		jurisdiction: ["UK"],
	},
	{
		title: "Tax Details",
		child: TaxDetails,
		icon: ReceiptPercentIcon,
		modalType: ["default"],
		jurisdiction: ["UK", "MT"],
	},
	{
		title: "Contactor Verification",
		child: TaxDetails,
		icon: ReceiptPercentIcon,
		modalType: ["cis"],
		jurisdiction: ["UK", "MT"],
	},
	{
		title: "Bank Details",
		child: Bank,
		icon: BuildingLibraryIcon,
		modalType: ["default", "cis"],
		jurisdiction: ["UK", "MT"],
	},
	{
		title: "Confirmation",
		child: FinalConfirmation,
		icon: CheckBadgeIcon,
		modalType: ["default", "cis"],
		jurisdiction: ["UK", "MT"],
	},
];

const AddEmployeeModal = ({
	setNewEmployeeModal,
	isNewEmployeeModalOpen,
	employeesGetListWithSalary,
	employeeDetails,
	jurisdiction,
	roleExists,
	salaryExists,
	engagementExists,
	pensionExists,
	occupation,
	modalType,
}) => {
	const fullName = employeeDetails ? employeeDetails?.givenName + " " + employeeDetails?.familyName : "New Employee";

	const jurisdictionPages = useMemo(() => {
		return pageList.filter(
			(item) => item.jurisdiction.includes(jurisdiction) && item.modalType.includes(modalType),
		);
	}, [jurisdiction, modalType]);

	const [page, setPage] = useState(0);
	const [maxPage, setMaxPage] = useState(0);
	const lastPage = jurisdictionPages.length;
	console.log("page",modalType,jurisdictionPages)
	const currentPage = jurisdictionPages[page];

	useEffect(() => {
		if (engagementExists) setMaxPage(jurisdictionPages.findIndex(({ title }) => title == "Role Details"));
		if (roleExists) setMaxPage(jurisdictionPages.findIndex(({ title }) => title == "Salary Details"));
		if (salaryExists) setMaxPage(jurisdictionPages.findIndex(({ title }) => title == "Tax Details"));
		if (salaryExists && !pensionExists && jurisdiction == "UK")
			setMaxPage(jurisdictionPages.findIndex(({ title }) => title == "Pension Plan"));
		return () => setMaxPage(0);
	}, [roleExists, salaryExists, engagementExists, pensionExists]);

	useEffect(() => {
		if (page > maxPage) setMaxPage(page);
	}, [page]);

	const nextPage = () => {
		if (page + 1 === lastPage) {
			employeesGetListWithSalary();
			setNewEmployeeModal(false);
			setPage(0);
		} else setPage(page + 1);
	};

	const prevPage = () => {
		setPage(page - 1);
	};

	const closeModal = () => {
		if (page != 0) employeesGetListWithSalary();
		setNewEmployeeModal(false);
		setMaxPage(0);
		setPage(0);
	};

	if (!isNewEmployeeModalOpen) return null;

	return (
		<div
			className="modal"
			tabIndex="-1"
			role="dialog"
			aria-hidden="true"
			style={{ display: "block", background: "rgba(0,0,0,0.4)", overflow: "auto" }}
		>
			<div
				className="modal-dialog"
				style={{ width: "75%" }}
			>
				<div className="modal-content">
					<div className="block block-themed block-transparent remove-margin-b p-0">
						<div
							className="block-header bg-primary-dark"
							style={{ padding: 20, position: "sticky", top: 0, zIndex: 50 }}
						>
							<ul className="block-options">
								<li>
									<button
										type="button"
										onClick={closeModal}
									>
										<XMarkIcon className="h-6 w-6 mr-3 text-white" />
									</button>
								</li>
							</ul>
							<h3 className="block-title">
								{fullName} - {currentPage?.title}
							</h3>
						</div>
						<div
							className="block-content bg-white"
							style={{ paddingTop: 20, position: "sticky", top: "6rem", zIndex: 50 }}
						>
							<ul className="progress-bar-nav">
								{jurisdictionPages.map((pageItem, index) => {
									return (
										<li
											style={{ width: `${(1 / jurisdictionPages.length) * 100}%` }}
											className={`${page == index ? "current " : ""}${
												maxPage >= index ? "active" : ""
											}`}
										>
											<div className="progress-bar-nav-line"></div>
											<div
												className="progress-bar-nav-icon"
												style={{ cursor: maxPage >= index ? "pointer" : "auto" }}
												onClick={() => {
													if (maxPage < index) return;
													setPage(index);
												}}
											>
												{pageItem.icon && <pageItem.icon />}
											</div>
											{pageItem.title}
										</li>
									);
								})}
							</ul>
							<div className="clearfix" />
						</div>
						<div
							className="block-content"
							style={{ paddingBottom: "2rem", paddingLeft: "2rem", paddingRight: "2rem", paddingTop: 0 }}
						>
							<currentPage.child
								forNewEmployee={true}
								occupation={occupation}
								type={modalType}
								prevPage={page > 0 ? prevPage : null}
								nextPage={page < lastPage ? nextPage : null}
							/>
						</div>
						<div className="clearfix" />
					</div>
				</div>
			</div>
		</div>
	);
};

const mapStateToProps = (state, ownProps) => {
	const engagementExists = !!state.employee?.agreementInfo?.engagementDate;
	const roleExists = !!state.employee?.roles?.[0]?.id;
	const salaryExists = !!state.employee?.salaries?.[0]?.id;
	const pensionExists = !!state.employee?.pensionPlans?.[0]?.id;

	const [ occupation ] = state.employee?.agreementInfo?.occupations || [];
	
	return {
		roleExists,
		salaryExists,
		engagementExists,
		pensionExists,
		isNewEmployeeModalOpen: state.isNewEmployeeModalOpen,
		jurisdiction: state.company?.settings?.jurisdiction,
		employeeDetails: state.employee?.agreementInfo?.employeeDetails,
		occupation,
		modalType: state.employee?.type ||	state.employee?.agreementInfo?.type || "default",
	};
};

const mapDispatchToProps = (dispatch) => ({
	setNewEmployeeModal: (isNewEmployeeModal, keepEmployee, details) =>
		dispatch(EMPLOYEEACTIONS.setNewEmployeeModal(isNewEmployeeModal, keepEmployee, details)),
	employeesGetListWithSalary: () =>
		dispatch(
			EMPLOYEEACTIONS.employeesGetListWithSalary(
				{
					from: format(addMonths(new Date(), -2), "yyyy-MM-01"), // get list from last 2 months
					to: format(new Date(), "yyyy-12-31"),
				},
				{ includeTax: true },
			),
		),
});

export default connect(mapStateToProps, mapDispatchToProps)(AddEmployeeModal);
